module.exports = __webpack_public_path__ + "img/f4.e08996e9.png";